import React from "react";
import Panda from "./Panda";

// Offscreen render of story slides as a shareable image strip (3 tiles per row).
const StoryStrip = React.forwardRef(({ slides, heading }, ref) => (
  <div style={{ position: "fixed", left: -10000, top: 0 }} aria-hidden="true">
  <div ref={ref} style={{ width: 1200, background: "#f7fdfe", padding: 32, fontFamily: "Work Sans, Arial, sans-serif" }} data-testid="story-strip">
    <p style={{ margin: 0, color: "#1b8bc9", fontStyle: "italic", fontWeight: 700, fontSize: 18 }}>Teach your child Credit</p>
    <p style={{ margin: "4px 0 20px", color: "#0c4a6e", fontWeight: 700, fontSize: 34, fontFamily: "Literata, serif" }}>{heading}</p>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
      {slides.map((s, k) => {
        const fg = s.dark ? "#5a4600" : "#ffffff";
        const pandas = (s.pandas || [s.panda]).filter(Boolean);
        return (
          <div key={k} style={{ background: s.bg, color: fg, borderRadius: 24, padding: 20, minHeight: 230, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", justifyContent: "center" }}>
            <div style={{ display: "flex", gap: 6 }}>{pandas.map((p, j) => <Panda key={j} size={pandas.length > 1 ? 54 : 70} accessory={p.accessory} scarf={p.scarf} item={s.item} />)}</div>
            <p style={{ margin: "10px 0 0", fontSize: 12, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", opacity: 0.9, whiteSpace: "nowrap" }}>{s.title}</p>
            <p style={{ margin: "10px 0 0", fontSize: String(s.big).length > 8 ? 28 : 54, fontWeight: 700, lineHeight: 1.1, fontFamily: "Literata, serif" }}>{s.big}</p>
            <p style={{ margin: "8px 0 0", fontSize: 14, fontWeight: 500, opacity: 0.95 }}>{s.sub}</p>
          </div>
        );
      })}
    </div>
    <p style={{ margin: "20px 0 0", color: "#9ca3af", fontSize: 13, textAlign: "center" }}>Based on the book by Ken Bossard, MBA · teachyourchildcredit.com</p>
  </div>
  </div>
));

export default StoryStrip;
